import { render, staticRenderFns } from "./ReviewResult.vue?vue&type=template&id=bae9e0fa&scoped=true&"
import script from "./ReviewResult.vue?vue&type=script&lang=js&"
export * from "./ReviewResult.vue?vue&type=script&lang=js&"
import style0 from "./ReviewResult.vue?vue&type=style&index=0&id=bae9e0fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae9e0fa",
  null
  
)

export default component.exports